import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import { getOrganizations, setOrganizationsCurrentPage } from '~/apps/shared/actions/organizations';
import OrgListTable from '../../components/orgs/OrgListTable';


class OrganizationList extends React.Component<any, any> {
  onFetchData = (state, instance) => {
    const { dispatch } = this.props;
    dispatch(getOrganizations(state.page * state.pageSize));
  };

  onShowUsers = (org) => {
    navigate('admin.orgs.users', {orgId: org.id});
  };

  onShowLocations = (org) => {
    navigate('admin.orgs.locations', {orgId: org.id});
  };


  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setOrganizationsCurrentPage(page));
  };

  render() {
    const { orgs  } = this.props;

    return (
      <OrgListTable
        manual={true}
        loading={orgs.ui.loading}
        page={orgs.ui.currentPage}
        data={orgs.ui.currentList.map(c => orgs.entities[c])}
        onFetchData={this.onFetchData}
        onOrganizationClick={this.onShowLocations}
        onPageChange={this.onPageChange}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orgs: state.shared.organizations,
  }
};

const mapDispatchToProps = (dispatch: Function, { history }) => {
  return {
    dispatch,
    history,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationList) as any;
